import { Grid } from '@ts/storybook';
import { IForm } from '@ts/ui-models';
import Devices from '@pages/DataBase/Flavors/Devices/Devices';

interface IEventTypeDevicesTriggerTabProps extends IForm {}

const EventTypeDevicesTriggerTab = (props: IEventTypeDevicesTriggerTabProps) => {
  const { values } = props;
  // Cargar devices cuando no es "new"
  /*   useEffect(() => {
    if (mode !== 'new') {
      const id = values.id;
      const needs = [{ url: `/api/eventType/${id}/devices`, dataPath: `et_${id}_devices` }];
      const needsManager = new NeedsManager(data, needs);
      needsManager.fetchNeeds();
    }
  }, [mode, values.id, data]); */

  // Normalizamos devices a array plano
  /*   const devices: any[] = useMemo(() => {
    if (mode === 'new') return [];

    const id = values.id;
    const raw = data?.getIn ? data.getIn([`et_${id}_devices`, 'data']) : data?.[`et_${id}_devices`]?.data;

    if (!raw) return [];
    if (Array.isArray(raw)) return raw;
    if (typeof raw.toJS === 'function') return raw.toJS();

    return raw;
  }, [mode, values.id, data]);
      {/* <DeviceTable
          key={t('Device triggers')}
          title={t('Devices that triggers events of this type')}
          app={app}
          data={data}
          devices={devices}
          fnChange={fnChange}
        /> */

  return (
    <Devices
      title="Devices that triggers events of this type"
      configComponent={{
        componentId: 'devicedTriggers',
        aclId: 'tsElement',
        fetchURL: `/api/eventType/${values.getID()}/devices`,
      }}
    />
  );
};

export default EventTypeDevicesTriggerTab;
